import ReactSelect from 'react-select';
import { themedSelectStyles } from './selectStyles';

// Drop-in replacement for react-select's default export that applies the
// theme-aware styles (see selectStyles.js) so dropdowns follow data-bs-theme.
// A caller's own `styles` prop still wins, layered on top of the themed defaults.
export default function ThemedSelect({ styles, ...props }) {
    const mergedStyles = { ...themedSelectStyles, ...(styles || {}) };
    return <ReactSelect styles={mergedStyles} {...props} />;
}
